import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IRoute } from '../../../../../core/interfaces/route.interface';
import { IStateService } from 'angular-ui-router';

interface IPageCP0008 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}
/* @ngInject */
export default function Cp0008Controller(Menu: IMenuClass,
    Formulaire: IFormulaireClass,
    MenuItemAction: IMenuItemActionClass,
    FormulaireItem: IFormulaireItemClass,
    $state: IStateService,
    cp0013Route: IRoute) {
    const vm: IPageCP0008 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        actionsMoreLigne: new Menu([
            new MenuItemAction(
                'LBL_BTN_COMPLETER',
                'BOUCOM',
                (data: any) => ({ lcpcleint: data.lcpcleint }),
                {
                    hidden: (data: any) => (!data.lcpindcom),
                    fonction: 'BOUCOM',
                    icon: 'update'
                }
            ),
            new MenuItemAction(
                'LBL_BNT_REPORTER',
                'BOUREP',
                (data: any) => ({ lcpcleint: data.lcpcleint }),
                {
                    hidden: (data: any) => (!data.lcpindrep),
                    fonction: 'BOUREP',
                    icon: 'update'
                }
            ),
            new MenuItemAction(
                'LBL_BNT_DEP',
                'BOUDEP',
                (data: any) => ({ redcleint: data.redcleint, lcpcleint: data.lcpcleint }),
                {
                    fonction: 'BOUDEP',
                    icon: 'update',
                    successAction: (data: any) => $state.go(cp0013Route.NAME, { id: data.lcpcleint }),
                }
            ),
        ]),
        colonnesVisibles: [
            { nom: 'lcpcod', largeur: 89 },
            { nom: 'peccod', largeur: 89 },
            { nom: 'lcpstu', largeur: 84 },
            { nom: 'usrcod', largeur: 100 },
            { nom: 'lcpflgstu', largeur: 72 },
            { nom: 'lcpindcom', largeur: 100 },
            { nom: 'lcpindrep', largeur: 91 },
            { nom: 'redcod', largeur: 125 },
            { nom: 'reddsc', largeur: 245 },
            { nom: 'lcpdatrep', largeur: 120 },
            { nom: 'nbrtrs', largeur: 91 },
            { nom: 'nbrrep', largeur: 91 },
            { nom: 'mnttrs', largeur: 126 },
            { nom: 'lcpdsc', largeur: 310 }
        ],
        colonnesCachees: ['lcpcleint', 'redcleint'],
        formulaire: new Formulaire([
            new FormulaireItem('lcpcod', { largeur: 33 }),
            new FormulaireItem('lcpindcom', { largeur: 33 }),
            new FormulaireItem('lcpflgstu', { largeur: 33 }),
            new FormulaireItem('peccleint', { largeur: 33 }),
            new FormulaireItem('lcpindrep', { largeur: 33 }),
            new FormulaireItem('lcpstu', { largeur: 33 }),
            new FormulaireItem('lcpdatrep', { largeur: 33 }),
            new FormulaireItem('redcleint', { largeur: 33 }),
            new FormulaireItem('lcpdsc', { largeur: 33 }),
            new FormulaireItem('nbrtrs', { largeur: 33 }),
            new FormulaireItem('nbrrep', { largeur: 33 }),
            new FormulaireItem('mnttrs', { largeur: 33 })
        ])
    };
}
